// This file is generated by pnpm icons:generate. Do not edit.

import {CircleAndSquare_Stroke1_Corner0_Rounded_Filled as CanonicalCircle_And_Square_Stroke1_Corner0_Rounded_Filled} from './Circle'

/** @deprecated Import CircleAndSquare_Stroke1_Corner0_Rounded_Filled from `#/components/icons/Circle` instead. */
export const Circle_And_Square_Stroke1_Corner0_Rounded_Filled =
  CanonicalCircle_And_Square_Stroke1_Corner0_Rounded_Filled
